module.exports = __webpack_public_path__ + "static/media/1970363729_20190214_144123_3591804_resized.0e961623.JPG";